// extracted by mini-css-extract-plugin
export default {"page":"C9-z","cartModal":"D9-z","checkout":"E9-z","placeholder":"F9-z","account":"G9-z"};